const reportWebVitals = (onPerfEntry?: any) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then((webVitals) => {
      // Support both v2 (getCLS) and v3 (onCLS) APIs
      const { getCLS, getFID, getFCP, getLCP, getTTFB, onCLS, onFID, onFCP, onLCP, onTTFB } = webVitals as any;

      if (onCLS) {
        onCLS(onPerfEntry);
        onFID?.(onPerfEntry);
        onFCP?.(onPerfEntry);
        onLCP?.(onPerfEntry);
        onTTFB?.(onPerfEntry);
      } else if (getCLS) {
        getCLS(onPerfEntry);
        getFID?.(onPerfEntry);
        getFCP?.(onPerfEntry);
        getLCP?.(onPerfEntry);
        getTTFB?.(onPerfEntry);
      }
    });
  }
};

export default reportWebVitals;
